import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DataQueryDto } from '../../shared/dto/data-query.dto';

@Component({
  selector: 'wl-query-tool-view-sql',
  templateUrl: './query-tool-view-sql.component.html',
  styleUrls: ['./query-tool-view-sql.component.less'],
    standalone: false
})
export class QueryToolViewSqlComponent {
  @Input() dataQueryDto: DataQueryDto;
}
